<template>
  <div class="component-container">
      <div class="second-edition" id="second-edition">
        <h3>5LNG Matter and Energy in an Ecosystem - Downloads and Resources</h3>

      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>
      <div class="presentations">
        <h4>Teacher Presentations</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2F5LNG-2E_Activities_1-5_08262024.zip?alt=media&token=d5c7b610-bd16-4b2f-8674-0a6a5bd025e6" target="_blank">Teacher Presentations: Activities 1 - 5</a> - Updated 8/26/2024</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Student Journals</h4>
        <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1hlVQzlsDvLawiAm1gi5iLAL9VDlbFxMUl9tHAS4zrrM/copy" target="_blank">5LNG Second Edition: Matter and Energy in an Ecosystem Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/1h_9g2lRxFMrGX7Dt7URMZcur1KFmVrhI/view" target="_blank">5LNG Second Edition: Matter and Energy in an Ecosystem Student Journal Answer Key</a></li>
          <li><a href="https://docs.google.com/presentation/d/146BHfWuWhPp32-dGx_WmyOgqp1BrTz1cG0-BxGsQGNo/copy" target="_blank">5LNG Second Edition: Matter and Energy in an Ecosystem Student Journal - SPANISH</a></li>
        </ul>

      </div>
      <div class="presentations">
        <h4>Individual Resources</h4>
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1TeGNhJzO7rMIiIIPjgkzj446b70Ub1JFrX22gWNWKGk/copy" target="_blank">Planting of Seeds - Handout</a></li>
          <li><a href="https://docs.google.com/presentation/d/1rSqDomTLXVd5muBF9h_jmolZfOx5xvUZ5_Ybz8FEF0M/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1v2K2aJIbnBcyIc-PGTYu2e5BUjeA9HC3xyLxoew9gAs/copy" target="_blank">Anchor Posters</a></li>
          <li><a href="https://docs.google.com/presentation/d/1jI5BFAis3K_sntb7kPa0eL2fGSYvFepEy910oEYXUE4/copy" target="_blank">Word Wall</a></li>
          <li><a href="https://docs.google.com/presentation/d/1uG1iaJv1gd9scR08oMJog-GsUqHhwlt-RtVaE_Fus9A/copy" target="_blank">Food Web Card Set</a></li>
          <li><a href="https://jamboard.google.com/d/1P30EIPNg-jnMoCqInUXMCmBFCCORKyqdigEUyNcGC9M/copy" target="_blank">Bottle Ecosystem Investigation Proposal - Handout</a></li>
          <li><a href="https://docs.google.com/presentation/d/1FX3QjLYjjdnpa3f0rgFgWZ-mT2GqsiDLnVJxjRJMLLU/copy" target="_blank">Building Our Bottle Ecosystems - Handout</a></li>
          <li><a href="https://docs.google.com/presentation/d/1T0GhNamxjcCZuEhaTZULVZ5_AqyIlMnhh8UrXYhMDk4/copy" target="_blank">Bottle Ecosystem Observation Log</a></li>
          <li><a href="https://docs.google.com/document/d/1cIQ7kBymIZxLml3v3jmWObLsKDrxsGLAzkuFIxmzWWk/copy" target="_blank">Ecology Data Table</a></li>
          <li><a href="https://docs.google.com/presentation/d/1FP5YV1wZ99Akv3pfyzfikEJ9lidqIdaGNg2ATeE12tk/copy" target="_blank">Word Sort Cards - Lesson 2C</a></li>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/pdf%2FStaying_Alive_by_Gary_Miller.pdf?alt=media&token=c8e3d13a-308f-4b04-9d52-9996d431e46e" target="_blank">Article: Staying Alive by Gary Miller</a></li>
          <li><a href="https://docs.google.com/presentation/d/1tXUDV0NZ6QXl0-ETvl5kVI0z4SjzMT9AJvf3MoKBtEo/copy" target="_blank">Light Collectors / Sealed Jar Handouts - Lesson 4B</a></li>
          <li><a href="https://docs.google.com/presentation/d/1pNO1eel50XnOZHavMA4hrIpyA0z26qXqxxY6fghqj0I/copy" target="_blank">Ecosystem Pictures & Eco-Players Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1WnaJ_DCb2tLrThTKAJxAUVdy0KEamopO3YNuQ5mhPcE/copy" target="_blank">Ecosystem Change Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1OqCZCAuBjuCr5UWyVJMM8MsmzGvRY3kTem1875uTLVY/copy" target="_blank">Invasive Species Research and Presentation Handouts - Lesson 5C</a></li>
          <li><a href="https://docs.google.com/presentation/d/1p4YUcnIl_MIiOtD9Y_9iL59R0_Fz7ctHll2VofPMxbM/copy" target="_blank">Word Sort Cards - Lesson 5D</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->

        </ul>
        
      </div>
    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>
